import React from 'react';
import {FormattedMessage, FormattedDate} from 'react-intl';

const Informacion =() => {
	
	return (

    		<div className = "container"> 
			    <p class=" parrafoinformacion my-2 my-lg-5 card-text text-secondary">  	
                     <FormattedMessage 
					           id="app.Ciberseguriti"
								defaultMessage="Nuestra consultora les ofrece servicios de auditoría y pruebas de penetración (pentesting) en su software,
 detectando problemas de seguridad e identificación temprana de vulnerabilidades, para ayudarle a mitigar los riesgos
antes que estos sean explotados por atacantes. Nuestro servicios incluyen:"
								values={
									{
										name: 'Ciberseguriti'
								    }
							    }/>
			    </p>

					 <div className="parrafoinformacion my-2 my-lg-5 card-text text-secondary">
						
						
					
						<li id="mi-lista">
						       <FormattedMessage 
					           id="app.ServiciosOfrecidos1"
								defaultMessage="Auditoría de código:"
								values={
									{
										name: 'ServiciosOfrecidos1'
								    }
							    }/>
								
								<p>  	
                                <FormattedMessage 
					            id="app.DescripcionServiciosOfrecidos1"
								defaultMessage="Revisamos su código fuente en busca de vulnerabilidades, errores de lógica y malas prácticas de seguridad."
								values={
									{
										name: 'DescripcionServiciosOfrecidos1'
								    }
							    }/></p>
					    </li>
						
						<li id="mi-lista">
						       <FormattedMessage 
					           id="app.ServiciosOfrecidos2"
								defaultMessage="Pruebas de penetración (Pentesting):"
								values={
									{
										name: 'ServiciosOfrecidos2'
								    }
							    }/>
						       <p>  	
                                <FormattedMessage 
					            id="app.DescripcionServiciosOfrecidos2"
								defaultMessage="Simulamos ataques cibernéticos a su software para identificar vulnerabilidades en tiempo real y evaluar la efectividad de sus medidas de seguridad."
								values={
									{
										name: 'DescripcionServiciosOfrecidos2'
								    }
							    }/></p>
					          
					    </li>
						
						<li id="mi-lista">  
						      <FormattedMessage 
					           id="app.ServiciosOfrecidos3"
								defaultMessage="Análisis de vulnerabilidades:"
								values={
									{
										name: 'ServiciosOfrecidos3'
								    }
							    }/>
								<p>  	
                                <FormattedMessage 
					            id="app.DescripcionServiciosOfrecidos3"
								defaultMessage="Identificamos y clasificamos las vulnerabilidades encontradas, con recomendaciones detalladas para su solucion."
								values={
									{
										name: 'DescripcionServiciosOfrecidos3'
								    }
							    }/></p>
					    </li>
					  
					    <li id="mi-lista">  
						      <FormattedMessage 
					           id="app.ServiciosOfrecidos4"
								defaultMessage="Informes detallados:"
								values={
									{
										name: 'ServiciosOfrecidos4'
								    }
							    }/>
								<p>  	
                                <FormattedMessage 
					            id="app.DescripcionServiciosOfrecidos4"
								defaultMessage="Entregamos informes claros y concisos con hallazgos, niveles de criticidad y recomendaciones prácticas para proteger su software."
								values={
									{
										name: 'DescripcionServiciosOfrecidos4'
								    }
							    }/></p>
					    </li>
						
						<li id="mi-lista">  
						      <FormattedMessage 
					           id="app.ServiciosOfrecidos5"
								defaultMessage="Asesoramiento técnico:"
								values={
									{
										name: 'ServiciosOfrecidos4'
								    }
							    }/>
								<p>  	
                                <FormattedMessage 
					            id="app.DescripcionServiciosOfrecidos5"
								defaultMessage="Por cualquier consulta contactenos a traves del formulario de este sitio y nos comunicaremos a la brevedad."
								values={
									{
										name: 'DescripcionServiciosOfrecidos5'
								    }
							    }/></p>
					    </li>
				        
					  </div>
				
    
				<p class="parrafoinformacion my-2 my-lg-5 card-text text-secondary">  	
                     <FormattedMessage 
					           id="app.Contactenos"
								defaultMessage="Proveemos un servicio de guía y asesoramiento a través de la aplicación de un set de buenas prácticas para que la implementación de un programa sea segura."
								values={
									{
										name: 'Contactenos'
								    }
							    }/>
			    </p>
			</div>
     )	
}
export default Informacion